module.exports = __webpack_public_path__ + "img/correcao-estatica-tomografia-5.d4701ffb.png";